module.exports = {"id":"193532","name":"Gary Medel","rating":"81","photo":"./data/images/photos/3/193532.png","club":{"name":"Beşiktaş","logo":"./data/images/clubs/Besiktas.png"},"positions":["MDC","DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GaryMedel0.json
// module id = 1536
// module chunks = 0